/**
 * Live character counter for Contact Form 7 textareas.
 *
 * Pairs any `textarea.wpcf7-form-control[maxlength]` with the [data-cf7-char-count]
 * element authored right after it in the same CF7 form markup. The counter text
 * template (e.g. "{count} z 600 znaków") lives entirely in that data attribute —
 * this script only ever replaces the "{count}" placeholder, never hardcodes copy.
 */

/**
 * Update a single counter element to reflect its paired textarea's current length.
 *
 * @param {HTMLTextAreaElement} textarea Source textarea with a maxlength attribute.
 * @param {HTMLElement}         counter  Element carrying the [data-cf7-char-count] template.
 * @return {void}
 */
const updateCf7CharCount = ( textarea, counter ) => {

	const template = counter.dataset.cf7CharCount;

	if ( ! template ) {

		return;

	}

	counter.textContent = template.replace( '{count}', String( textarea.value.length ) );

};

/**
 * Wire up every CF7 textarea/counter pair found on the page.
 *
 * @return {void}
 */
const initCf7CharCounters = () => {

	document.querySelectorAll( 'textarea.wpcf7-form-control[maxlength]' ).forEach( ( textarea ) => {

		const wrap = textarea.closest( '.wpcf7-form-control-wrap' );
		const counter = wrap?.nextElementSibling;

		if ( ! counter?.matches( '[data-cf7-char-count]' ) ) {

			return;

		}

		textarea.addEventListener( 'input', () => updateCf7CharCount( textarea, counter ) );
		updateCf7CharCount( textarea, counter );

	} );

};

document.addEventListener( 'DOMContentLoaded', initCf7CharCounters );
